import {
  CUSTOM_ELEMENTS_SCHEMA,
  ModuleWithProviders,
  NgModule,
  NO_ERRORS_SCHEMA,
  provideZoneChangeDetection,
} from '@angular/core';
import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { PrimengModule } from './primeng/primeng.module';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutComponent } from '../../components/layout/layout.component';
import { LeftMenuComponent } from '../../components/layout/left-menu/left-menu.component';
import { HeaderComponent } from '../../components/layout/header/header.component';
import { IntegrationBlockComponent } from '../../components/integration-block/integration-block.component';
import { RightMenuComponent } from '../../components/layout/right-menu/right-menu.component';
import { FooterComponent } from '../../components/layout/footer/footer.component';
import { PortalModule } from '@angular/cdk/portal';
import { BoardComponent } from '../../components/board/board.component';
import { DropRowComponent } from '../../components/drop-row/drop-row.component';
import { ContactsComponent } from '../../components/layout/right-sidebar/components/contacts/contacts.component';
import { RemindersComponent } from '../../components/layout/right-sidebar/components/reminders/reminders.component';
import { HandbookComponent } from '../../components/layout/right-sidebar/components/handbook/handbook.component';
import { CardOldComponent } from '../../components/layout/right-sidebar/components/card-old/card-old.component';
import { IntegrationNovaposhtaComponent } from '../../components/layout/right-sidebar/components/integration-novaposhta/integration-novaposhta.component';
import { HeaderSidebarComponent } from '../../components/layout/right-sidebar/components/header/header.component';
import { NotificationComponent } from '../../components/notifications/notifications.component';
import { InitDirective } from '../../directives/init.directive';
import { CdkContextMenuTrigger, CdkMenu, CdkMenuItem, CdkMenuTrigger } from '@angular/cdk/menu';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';
import { IntegrationOlxComponent } from '../../components/layout/right-sidebar/components/integration-olx/integration-olx.component';
import { DropdownComponent } from '../../components/dropdown/dropdown.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ButtonComponent } from '../../components/button/button.component';
import { ChannelComponent } from '../../dialogs/channel/channel.component';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ScrollingModule as CdkExperimentalScrollingModule } from '@angular/cdk-experimental/scrolling';
import { ModalComponent } from '../../components/modal/modal.component';
import { ProductInfoComponent } from '../../components/product-info/product-info.component';
import { TextFieldComponent } from '../../components/text-field/text-field.component';
import { DialogComponent } from '../../components/dialog/dialog.component';
import { ConfirmComponent } from '../../dialogs/confirm/confirm.component';
import { AdditionalInfoComponent } from '../../pages/additional-info/additional-info.component';
import { IntegrationTelegramComponent } from '../../components/layout/right-sidebar/components/integration-telegram/integration-telegram.component';
import { TableComponent } from '../../components/table/table.component';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { PhoneFieldComponent } from '../../components/phone-field/phone-field.component';
import { ChannelsComponent } from '../../components/layout/right-sidebar/components/channels/channels.component';
import { RadioComponent } from '../../components/radio/radio.component';
import { SearchComponent } from '../../components/search/search.component';
import { ResizerDirective } from '../../directives/resizer.directive';
import { PropsComponent } from '../../modals/props/props.component';
import { LoaderComponent } from '../../components/loader/loader.component';
import { TariffUpdateComponent } from '../../modals/tariff-update/tariff-update.component';
import { ThemesComponent } from '../../modals/themes/themes.component';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { TabInvoicesComponent } from '../../tabs/tab-invoices/tab-invoices.component';
import { DeliveryChoiceComponent } from '../../dialogs/delivery-choice/delivery-choice.component';
import { SyncTtnComponent } from '../../modals/sync-ttn/sync-ttn.component';
import { TabTemplatesComponent } from '../../tabs/tab-templates/tab-templates.component';
import { CreateTemplateComponent } from '../../components/modals/create-template/create-template.component';
import { FixTextComponent } from '../../components/dialogs/fix-text/fix-text.component';
import { SyncTtnDetailsComponent } from '../../components/modals/sync-ttn-details/sync-ttn-details.component';
import { PaginationComponent } from '../../components/table/pagination/pagination.component';
import { TabSupportVideoComponent } from '../../tabs/tab-support-video/tab-support-video.component';
import { TabSupportFaqComponent } from '../../tabs/tab-support-faq/tab-support-faq.component';
import { TabSupportTicketComponent } from '../../tabs/tab-support-ticket/tab-support-ticket.component';
import { TabFunnelsSettingsCommonComponent } from '../../tabs/tab-funnels-settings-common/tab-funnels-settings-common.component';
import { TabDealsSettingsFieldsComponent } from '../../tabs/tab-deals-settings-fields/tab-deals-settings-fields.component';
import { CreateDealsFields } from '../../components/modals/create-deals-fields/create-deals-fields.component';
import { CheckboxComponent } from '../../components/checkbox/checkbox.component';
import { ToggleComponent } from '../../components/toggle/toggle.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { ResizeColumnDirective } from '../../directives/resize-column.directive';
import { TabSupportContactComponent } from '../../tabs/tab-support-contact/tab-support-contact.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TabLogisticTelegramComponent } from '../../tabs/tab-logistic-telegram/tab-logistic-telegram.component';
import { NpTabTrackerInvoiceComponent } from '../../tabs/np-tab-tracker-invoice/np-tab-tracker-invoice.component';
import { UkrTabTrackerInvoiceComponent } from '../../tabs/ukr-tab-tracker-invoice/ukr-tab-tracker-invoice.component';
import { CreateTrackInvoiceComponent } from '../../dialogs/create-track-invoice/create-track-invoice.component';
import { MessageTemplatesComponent } from '../../bottom-sheet/message-templates/message-templates.component';
import { IntegrationCheckboxComponent } from '../../components/layout/right-sidebar/components/integration-checkbox/integration-checkbox.component';
import { CreateFunnelComponent } from '../../dialogs/create-funnel/create-funnel.component';
import { TabFunnelColumnsComponent } from '../../tabs/tab-funnel-columns/tab-funnel-columns.component';
import { CreateColumnComponent } from '../../modals/create-column/create-column.component';
import { BoardColumnEditComponent } from '../../modals/board-column-edit/board-column-edit.component';
import { PriceFieldComponent } from '../../components/price-field/price-field.component';
import { GoogleAddressTextFieldComponent } from '../../components/google-address-textfield/google-address-textfield.component';
import { TicketComponent } from '../../components/layout/right-sidebar/components/ticket/ticket.component';
import { HiddenInputComponent } from '../../components/hidden-input/hidden-input.component';
import { MyPacketsComponent } from '../power-olx/components/my-packets/my-packets.component';
// @ts-ignore
// import Data from '@types/google.maps';
import { DateAgoPipe } from '../../pipes/date.pipe';
import { DaysLeftPipe } from '../../pipes/days-left.pipe';
import { MyAdvertsComponent } from '../power-olx/components/my-adverts/my-adverts.component';
import { MyTemplatesComponent } from '../power-olx/components/my-templates/my-templates.component';
import { ActivityComponent } from '../../components/activity/activity.component';
import { ChipComponent } from '../../components/chip/chip.component';
import { OneFieldComponent } from '../../dialogs/one-field/one-field.component';
import { DisableAutocompleteDirective } from '../../directives/disableAutocomplete.directive';
import { LinkifyPipe } from '../../pipes/linkify.pipe';
import { TeamComponent } from '../crm/team/components/team/team.component';
import { TabManagersComponent } from '../../tabs/tab-managers/tab-managers.component';
import { TabGroupsComponent } from '../../tabs/tab-groups/tab-groups.component';
import { TabInvitersComponent } from '../../tabs/tab-inviters/tab-inviters.component';
import { InviteManagerComponent } from '../../components/layout/right-sidebar/components/invite-manager/invite-manager.component';
import { InviteEmployeesComponent } from '../../components/layout/right-sidebar/components/invite-employees/invite-employees.component';
import { EmployeeProfileComponent } from '../../components/layout/right-sidebar/components/employee-profile/employee-profile.component';
import { CreateGroupComponent } from '../../components/layout/right-sidebar/components/create-group/create-group.component';
import { UpdateManagerComponent } from '../../components/layout/right-sidebar/components/update-manager/update-manager.component';
import { LoadDirective } from '../../directives/initv2.directive';
import { CreateChannelComponent } from '../../components/layout/right-sidebar/components/create-channel/create-channel.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { MyPlannersComponent } from '../power-olx/components/my-planners/my-planners.component';
import { IntegrationRingostatComponent } from '../../components/layout/right-sidebar/components/integration-ringostat/integration-ringostat.component';
import { IntegrationTelegramBotComponent } from '../../components/layout/right-sidebar/components/integration-telegram-bot/integration-telegram-bot.component';
import { ChanelRightBarComponent } from '../../modals/chanel-right-bar/chanel-right-bar.component';
import { AudioPlayerComponent } from '../../components/audio-player/audio-player.component';
import { AudioPlayerComponentV2 } from '../../components/audio-player-v2/audio-player-v2.component';
import { VisibilityObserverDirective } from '../../directives/visible.directive';
import { MyBackupsComponent } from '../power-olx/components/my-backups/my-backups.component';
import { PlannerComponent } from '../../modals/planner/planner.component';
import { TranslateDirective, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TranslationModuleDirective } from '../../core/i18n';
import { provideHttpClient, withXhr } from '@angular/common/http';
import { ProfileComponent } from '../crm/settings/components/profile/profile.component';
import { SettingsComponent } from '../crm/settings/components/settings/settings.component';
import { HomeComponent } from '../../pages/home/home.component';
import { LoginComponent } from '../../pages/login/login.component';
import { CompaniesComponent } from '../../pages/companies/companies.component';
import { SingleAuthComponent } from '../../pages/single-auth/single-auth.component';
import { PolicyComponent } from '../../pages/policy/policy.component';
import { MarketComponent } from '../market/components/market/market.component';
import { IntegrationAiComponent } from '../../components/layout/right-sidebar/components/integration-ai/integration-ai.component';
import { ChangeOlxPriceComponent } from '../../modals/change-olx-price/change-olx-price.component';
import { ChartComponent } from '../../components/chart/chart.component';
import { FileSizePipe } from '../../pipes/file-size.pipe';
import { SnackBarComponent } from '../../components/snack-bar/snack-bar.component';
import { CreateUpdateOlxAdvertComponent } from '../../components/layout/right-sidebar/components/create-update-olx-advert/create-update-olx-advert.component';
import { CompanySettingsComponent } from '../crm/settings/components/company-settings/company-settings.component';
import { CreateAdsComponent } from 'src/app/components/layout/right-sidebar/components/create-ads/create-ads.component';
import { FileViewerComponent } from 'src/app/components/file-viewer/file-viewer.component';
import { MyDeliveriesComponent } from '../power-olx/components/my-deliveries/my-deliveries.component';
import { NotificationPopupComponent } from '../../dialogs/notification-popup/notification-popup.component';
import { BuyOlxPackageComponent } from '../../components/layout/right-sidebar/components/buy-olx-package/buy-olx-package.component';
import { FunnelFilterComponent } from '../../components/funnel-filter/funnel-filter.component';
import { PlannerAutomationComponent } from '../../modals/planner-automation/planner-automation.component';
import { IconComponent } from '../../components/icon/icon.component';
import { TagComponent } from '../../components/tag/tag.component';
import { TagsComponent } from '../../components/tags/tags.component';
import { AddFieldFilterComponent } from '../../components/modals/add-field-filter/add-field-filter.component';
import { ColorComponent } from '../../components/color/color.component';
import { RegisterComponent } from '../../pages/register/register.component';
import { VerifyingEmailComponent } from '../../components/modals/verifying-email/verifying-email.component';
import { ResetPasswordComponent } from '../../components/modals/reset-password/reset-password.component';
import { CreateSiteComponent } from '../../components/layout/right-sidebar/components/create-site/create-site.component';
import { CreateOrderSiteComponent } from '../../components/layout/right-sidebar/components/create-order-site/create-order-site.component';
import { ChatSidebarComponent } from '../../components/layout/chat-sidebar/chat-sidebar.component';
import { ChatListComponent } from '../../components/layout/chat-sidebar/components/chat-list/chat-list.component';
import { ChatComponent } from '../../components/layout/chat-sidebar/components/chat/chat.component';
import { ChatAboutComponent } from '../../components/layout/chat-sidebar/components/chat-about/chat-about.component';
import { ChatListItemComponent } from '../../components/layout/chat-sidebar/components/chat-list-item/chat-list-item.component';
import { ChatMessageComponent } from '../../components/layout/chat-sidebar/components/chat-message/chat-message.component';
import { ChatTimelineComponent } from '../../components/layout/chat-sidebar/components/chat-timeline/chat-timeline.component';
import { MarkdownModule } from 'ngx-markdown';
import { ChatAdvertInfoComponent } from '../../components/layout/chat-sidebar/components/chat-advert-info/chat-advert-info.component';
import { EmojiModule } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { ScrollDirective } from '../../directives/scroll.directive';
import { FileUploadNewComponent } from '../../modals/file-upload-new/file-upload-new.component';
import { CsvFieldMappingComponent } from '../../modals/csv-field-mapping/csv-field-mapping.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { FullNamePipe } from '../../pipes/full-name.pipe';
import { NoResultsComponent } from '../../components/no-results/no-results.component';
import { HighlightPipe } from '../../pipes/highlight.pipe';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { ChatSettingsComponent } from '../../components/layout/chat-sidebar/components/chat-settings/chat-settings.component';
import { LongPressDirective } from '../../directives/longpress.directive';
import { IntegrationRiaComponent } from '../../components/layout/right-sidebar/components/integration-ria/integration-ria.component';
import { IntegrationRingostatChannelComponent } from '../../components/layout/right-sidebar/components/integration-ringostat-channel/integration-ringostat-channel.component';
import { TextareaComponent } from '../../components/textarea/textarea.component';
import { IntegrationTelegramUserComponent } from '../../components/layout/right-sidebar/components/integration-telegram-user/integration-telegram-user.component';
import { TextareaAutoresizeDirective } from '../../directives/textarea-autoresize.directive';
import { CreateWidgetComponent } from '../../components/layout/right-sidebar/components/create-widget/create-widget.component';
import { RoundComponent } from '../../components/round/round.component';
import { MediaSecondsPipe } from '../../pipes/media-seconds.pipe';
import { LottieComponent } from 'ngx-lottie';
import { AvatarComponent } from '../../components/avatar/avatar.component';
import { ReactionsComponent } from '../../components/reaction/reactions.component';
import { CardComponent } from '../../components/layout/right-sidebar/components/card-v2/card.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { IntegrationInstagramComponent } from '../../components/layout/right-sidebar/components/integration-instagram/integration-instagram.component';
import { IntegrationFacebookComponent } from '../../components/layout/right-sidebar/components/integration-facebook/integration-facebook.component';
import { IntegrationTiktokComponent } from '../../components/layout/right-sidebar/components/integration-tiktok/integration-tiktok.component';
import { IntegrationActionComponent } from '../../components/utils/integration-action/integration-action.component';
import { OlxPricePipe } from '../../pipes/olx-price.pipe';
import { PhotoGalleryGroupDirective } from '../../directives/photo-gallery-group.directive';
import { PhotoGalleryDirective } from '../../directives/photo-gallery.directive';
import { AdvertActionComponent } from '../../components/layout/stacked-sidebar/components/advert-action/advert-action.component';
import { PriceEditorComponent } from '../../components/price-editor/price-editor.component';
import { SelectCategoryComponent } from '../../dialogs/select-category/select-category.component';
import { SelectFieldsComponent } from '../../dialogs/select-fields/select-fields.component';
import { GroupImagesPickerComponent } from '../../components/layout/stacked-sidebar/components/advert-action/components/advert-images-picker/group-images-picker.component';
import { AdvertCategoryPickerComponent } from '../../components/layout/stacked-sidebar/components/advert-action/components/advert-category-picker/advert-category-picker.component';
import { OlxLocationDropdownComponent } from '../../components/layout/stacked-sidebar/components/advert-action/components/olx-location-dropdown/olx-location-dropdown.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AdvertAttributesEditorComponent } from '../../components/layout/stacked-sidebar/components/advert-action/components/advert-attributes-editor/advert-attributes-editor.component';
import { ButtonToggleGroupComponent } from '../../components/button-toggle-group/button-toggle-group.component';
import { BuyOlxAdsBundlesComponent } from '../../components/layout/stacked-sidebar/components/buy-olx-ads-bundles/buy-olx-ads-bundles.component';
import { PlannerV2Component } from '../../components/layout/stacked-sidebar/components/planner-v2/planner-v2.component';
import { DropdownV2Component } from '../../components/dropdown-v2/dropdown-v2.component';
import { StackedSidebarComponent } from '../../components/layout/stacked-sidebar/stacked-sidebar.component';
import { AutomationLogDetailsComponent } from '../../components/layout/stacked-sidebar/components/automation-log-details/automation-log-details.component';
import { SuccessLeadComponent } from '../../modals/success-lead/success-lead.component';
import { IntegrationViberComponent } from '../../components/layout/right-sidebar/components/integration-viber/integration-viber.component';
import { WriteMessageComponent } from '../../modals/write-message/write-message.component';
import { InputComponent } from '../../components/input/input.component';
import { providePrimeNG } from 'primeng/config';
import { PRIMENG_LICENSE_KEY } from '../../config/primeng-license.config';
import Aura from '@primeuix/themes/aura';
import { SelectComponent } from '../../components/select/select.component';
import { definePreset, palette } from '@primeuix/themes';
import { BuyOlxPackagesV2Component } from '../../components/layout/stacked-sidebar/components/buy-olx-packages/buy-olx-packages-v2.component';
import { EmojiPipe } from '../../pipes/emoji.pipe';
import { TabsV2Component } from '../../components/tabs-v2/tabs.component';
import { TableV2Component } from '../../components/table-v2/table-v2.component';
import {
  TableV2CellDirective,
  TableV2EmptyDirective,
  TableV2HeaderDirective,
  TableV2RowAfterDirective,
} from '../../components/table-v2/table-v2.directives';
import { NotificationMenuComponent } from '../../components/layout/notification-menu/notification-menu.component';
import { PaymentHistoryTabComponent } from '../crm/pages/payment/payment-history-tab/payment-history-tab.component';
import { OtpComponent } from '../../components/modals/otp/otp.component';
import { IntegrationWhatsappComponent } from '../../components/layout/right-sidebar/components/integration-whatsapp/integration-whatsapp.component';
import { IntegrationPromComponent } from '../../components/layout/right-sidebar/components/integration-prom/integration-prom.component';
import { ShowAdvertStatisticsComponent } from '../../modals/show-advert-statistics/show-advert-statistics.component';
import { AdvertStatisticsChartComponent } from '../../modals/show-advert-statistics/components/advert-statistics-chart/advert-statistics-chart.component';
import { CompaniesV2Component } from '../../pages/companies-v2.component/companies-v2.component';
import { NeuronAndAnotherCrmComponent } from '../../components/layout/right-sidebar/components/neuron/another-crm/neuron-and-another-crm.component';
import { IntegrationReviewComponent } from '../../components/layout/right-sidebar/components/integration-review/integration-review.component';
import { NgxMaterialIntlTelInputComponent } from 'ngx-material-intl-tel-input';
import { Divider } from 'primeng/divider';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { BoardSelectFieldsFilterComponent } from '../../components/modals/board-select-fields-filter/board-select-fields-filter.component';
import { BoardV3Component } from '../../components/board-v3/board.component';
import { BoardV3DragActionFooterComponent } from '../../components/board-v3/drag-action-footer/drag-action-footer.component';
import { BoardV3CreateFunnelComponent } from '../../components/board-v3/sidebars/create-funnel/create-funnel.component';
import { ColumnHeaderComponent } from '../../components/board-v3/column-header/column-header.component';
import { ColumnBodyComponent } from '../../components/board-v3/column-body/column-body.component';
import { CardItemComponent } from '../../components/board-v3/card-item/card-item.component';
import { CardViewSettingsComponent } from '../../components/board-v3/sidebars/card-view-settings/card-view-settings.component';
import { QuickCreateCardComponent } from '../../components/board-v3/quick-create-card/quick-create-card.component';
import { QuickCreateSettingsComponent } from '../../components/board-v3/sidebars/quick-create-settings/quick-create-settings.component';
import { FieldsSettingsComponent } from '../../components/board-v3/sidebars/fields-settings/fields-settings.component';
import { BoardV3CardDetailComponent } from '../../components/board-v3/card-detail/card-detail.component';
import { BoardV3CardGeneralPanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-general-panel.component';
import { BoardV3CardCasePanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-case-panel/card-case-panel.component';
import { BoardV3CardCommentsPanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-comments-panel/card-comments-panel.component';
import { BoardV3CardChatsPanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-chats-panel/card-chats-panel.component';
import { BoardV3CardTasksPanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-tasks-panel/card-tasks-panel.component';
import { BoardV3CardCallsPanelComponent } from '../../components/board-v3/card-detail/card-general-panel/card-calls-panel/card-calls-panel.component';
import { TimelineComponent } from '../../components/timeline/timeline.component';
import { BoardV3TimelineUpdateComponent } from '../../components/board-v3/card-detail/card-timeline/timeline-update/timeline-update.component';
import { BoardV3TimelineReminderComponent } from '../../components/board-v3/card-detail/card-timeline/timeline-reminder/timeline-reminder.component';
import { BoardV3TimelineCommentComponent } from '../../components/board-v3/card-detail/card-timeline/timeline-comment/timeline-comment.component';
import { BoardV3TimelineCallComponent } from '../../components/board-v3/card-detail/card-timeline/timeline-call/timeline-call.component';
import { StageSettingsComponent } from '../../components/board-v3/sidebars/stage-settings/stage-settings.component';
import { ImportMappingComponent } from '../../components/board-v3/sidebars/import-mapping/import-mapping.component';
import { ExportFieldsComponent } from '../../components/board-v3/sidebars/export-fields/export-fields.component';
import { MoveCardComponent } from '../../components/board-v3/sidebars/move-card/move-card.component';
import { CallTranscriptComponent } from '../../components/board-v3/sidebars/call-transcript/call-transcript.component';
import { LeadConversionComponent } from '../../components/board-v3/sidebars/lead-conversion/lead-conversion.component';
import { LinkChatComponent } from '../../components/board-v3/sidebars/link-chat/link-chat.component';
import { BoardV3ContactFormComponent } from '../../components/board-v3/contacts/contact-form/contact-form.component';
import {
  BoardV3AddressEditorComponent,
  BoardV3PlaceAutocompleteDirective,
} from '../../components/board-v3/address-editor/address-editor.component';
import { BoardV3LinkContactComponent } from '../../components/board-v3/contacts/link-contact/link-contact.component';
import { BoardV3ContactDetailComponent } from '../../components/board-v3/contacts/contact-detail/contact-detail.component';
import { BoardV3CardContactsComponent } from '../../components/board-v3/contacts/card-contacts/card-contacts.component';
import { BoardV3ContactPickerComponent } from '../../components/board-v3/contacts/contact-picker/contact-picker.component';
import { BoardV3CompanyFormComponent } from '../../components/board-v3/companies/company-form/company-form.component';
import { BoardV3CompanyDetailComponent } from '../../components/board-v3/companies/company-detail/company-detail.component';
import { BoardV3CardCompanyComponent } from '../../components/board-v3/companies/card-company/card-company.component';
import { BoardV3CompanyPickerComponent } from '../../components/board-v3/companies/company-picker/company-picker.component';
import { BoardV3CardItemsComponent } from '../../components/board-v3/card-items/card-items.component';
import { BoardV3CardPaymentsComponent } from '../../components/board-v3/card-payments/card-payments.component';
import { PrroComponent } from '../../components/prro/prro.component';
import { CashRegisterFormComponent } from '../../components/prro/cash-register-form.component';
import { FiscalOperationDetailComponent } from '../../components/prro/fiscal-operation-detail.component';
import { FiscalHistoryComponent } from '../../components/prro/fiscal-history.component';
import { PaymentFiscalStatusComponent } from '../../components/payments/payment-fiscal-status/payment-fiscal-status.component';
import { FiscalReturnComponent } from '../../components/payments/payment-fiscal-status/fiscal-return.component';
import { PaymentFormComponent } from '../../components/payments/payment-form/payment-form.component';
import { PaymentServiceFormComponent } from '../../components/payments/payment-service-form/payment-service-form.component';
import { BoardV3CardNovaPoshtaComponent } from '../../components/board-v3/card-nova-poshta/card-nova-poshta.component';
import { NovaPoshtaSettingsComponent } from '../../components/nova-poshta/nova-poshta-settings/nova-poshta-settings.component';
import { NovaPoshtaShipmentFormComponent } from '../../components/nova-poshta/nova-poshta-shipment-form/nova-poshta-shipment-form.component';
import { NovaPoshtaLinkFormComponent } from '../../components/nova-poshta/nova-poshta-link-form/nova-poshta-link-form.component';
import { TaskStatusBadgeComponent } from '../../components/tasks/task-status-badge/task-status-badge.component';
import { TaskPriorityBadgeComponent } from '../../components/tasks/task-priority-badge/task-priority-badge.component';
import { TaskUserComponent } from '../../components/tasks/task-user/task-user.component';
import { TaskFieldsComponent } from '../../components/tasks/task-fields/task-fields.component';
import { TaskLinksComponent } from '../../components/tasks/task-links/task-links.component';
import { TaskRemindersComponent } from '../../components/tasks/task-reminders/task-reminders.component';
import { TaskTimelineComponent } from '../../components/tasks/task-timeline/task-timeline.component';
import { TaskFormComponent } from '../../components/tasks/task-form/task-form.component';
import { TaskDetailComponent } from '../../components/tasks/task-detail/task-detail.component';
import { TasksTodayComponent } from '../../components/tasks/tasks-today/tasks-today.component';
import { BoardV3WarehouseSettingsComponent } from '../../components/board-v3/sidebars/warehouse-settings/warehouse-settings.component';
import { WarehouseThumbComponent } from '../../components/warehouse/warehouse-thumb/warehouse-thumb.component';
import { WarehouseVariantPickerComponent } from '../../components/warehouse/variant-picker/variant-picker.component';
import { WarehouseProductFormComponent } from '../../components/warehouse/product-form/product-form.component';
import { WarehouseProductImportComponent } from '../../components/warehouse/product-import/product-import.component';
import { WarehouseFormComponent } from '../../components/warehouse/warehouse-form/warehouse-form.component';
import { WarehouseDocumentDetailComponent } from '../../components/warehouse/document-detail/document-detail.component';
import { BoardV3MergeCardsComponent } from '../../components/board-v3/merge-cards/merge-cards.component';
import { ChannelTypesComponent } from '../../components/layout/stacked-sidebar/components/channel-types/channel-types.component';
import { ChannelGroupFormComponent } from '../../components/layout/stacked-sidebar/components/channel-group-form/channel-group-form.component';
import { SectionFieldsDialogComponent } from '../../components/board-v3/sidebars/section-fields-dialog/section-fields-dialog.component';
import { CustomFieldControlComponent } from '../../components/board-v3/custom-field-control/custom-field-control.component';
import { BoardV3PresenceAvatarsComponent } from '../../components/board-v3/presence-avatars/presence-avatars.component';
import { BoardV3FiltersComponent } from '../../components/board-v3/sidebars/filters/filters.component';

const MyPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#EA5728'),
  },
});

const TABS = [
  NpTabTrackerInvoiceComponent,
  UkrTabTrackerInvoiceComponent,
  TabInvoicesComponent,
  TabSupportVideoComponent,
  TabSupportFaqComponent,
  TabSupportTicketComponent,
  TabTemplatesComponent,
  TabFunnelsSettingsCommonComponent,
  TabSupportContactComponent,
  TabDealsSettingsFieldsComponent,
  TabLogisticTelegramComponent,
  TabFunnelColumnsComponent,
  TabManagersComponent,
  TabGroupsComponent,
  TabInvitersComponent,
];

const BOTTOM_SHEETS = [MessageTemplatesComponent];

const COMPONENTS = [
  PaymentHistoryTabComponent,
  InputComponent,
  CreateWidgetComponent,
  ChatAdvertInfoComponent,
  PlannerComponent,
  LayoutComponent,
  PriceFieldComponent,
  RoundComponent,
  CardOldComponent,
  CardComponent,
  TicketComponent,
  GoogleAddressTextFieldComponent,
  MyAdvertsComponent,
  MyPlannersComponent,
  MyDeliveriesComponent,
  MyTemplatesComponent,
  ActivityComponent,
  ChipComponent,
  AvatarComponent,
  TeamComponent,
  InviteManagerComponent,
  InviteEmployeesComponent,
  EmployeeProfileComponent,
  CreateGroupComponent,
  UpdateManagerComponent,
  CreateChannelComponent,
  IntegrationRingostatComponent,
  IntegrationTelegramBotComponent,
  IntegrationTelegramUserComponent,
  AudioPlayerComponent,
  AudioPlayerComponentV2,
  MyBackupsComponent,
  ProfileComponent,
  SettingsComponent,
  CompanySettingsComponent,
  HomeComponent,
  LoginComponent,
  OtpComponent,
  RegisterComponent,
  CompaniesComponent,
  SingleAuthComponent,
  PolicyComponent,
  IntegrationAiComponent,
  LeftMenuComponent,
  RightMenuComponent,
  HeaderComponent,
  FooterComponent,
  IntegrationBlockComponent,
  BoardComponent,
  BoardV3Component,
  BoardV3DragActionFooterComponent,
  BoardV3PresenceAvatarsComponent,
  BoardV3CreateFunnelComponent,
  ColumnHeaderComponent,
  ColumnBodyComponent,
  CardItemComponent,
  CardViewSettingsComponent,
  QuickCreateCardComponent,
  QuickCreateSettingsComponent,
  BoardV3FiltersComponent,
  FieldsSettingsComponent,
  StageSettingsComponent,
  ImportMappingComponent,
  ExportFieldsComponent,
  MoveCardComponent,
  CallTranscriptComponent,
  LeadConversionComponent,
  BoardV3MergeCardsComponent,
  ChannelTypesComponent,
  ChannelGroupFormComponent,
  LinkChatComponent,
  BoardV3ContactFormComponent,
  BoardV3AddressEditorComponent,
  BoardV3PlaceAutocompleteDirective,
  BoardV3LinkContactComponent,
  BoardV3ContactDetailComponent,
  BoardV3CardContactsComponent,
  BoardV3ContactPickerComponent,
  BoardV3CompanyFormComponent,
  BoardV3CompanyDetailComponent,
  BoardV3CardCompanyComponent,
  BoardV3CompanyPickerComponent,
  BoardV3CardItemsComponent,
  BoardV3CardPaymentsComponent,
  PaymentFormComponent,
  PaymentFiscalStatusComponent,
  FiscalReturnComponent,
  PrroComponent,
  CashRegisterFormComponent,
  FiscalOperationDetailComponent,
  FiscalHistoryComponent,
  PaymentServiceFormComponent,
  BoardV3CardNovaPoshtaComponent,
  NovaPoshtaSettingsComponent,
  NovaPoshtaShipmentFormComponent,
  NovaPoshtaLinkFormComponent,
  TaskStatusBadgeComponent,
  TaskPriorityBadgeComponent,
  TaskUserComponent,
  TaskFieldsComponent,
  TaskLinksComponent,
  TaskRemindersComponent,
  TaskTimelineComponent,
  TaskFormComponent,
  TaskDetailComponent,
  TasksTodayComponent,
  BoardV3WarehouseSettingsComponent,
  WarehouseThumbComponent,
  WarehouseVariantPickerComponent,
  WarehouseProductFormComponent,
  WarehouseProductImportComponent,
  WarehouseFormComponent,
  WarehouseDocumentDetailComponent,
  IntegrationOlxComponent,
  DropRowComponent,
  ContactsComponent,
  RemindersComponent,
  NotificationComponent,
  HandbookComponent,
  ProductInfoComponent,
  DropdownComponent,
  DropdownV2Component,
  OlxLocationDropdownComponent,
  ColorComponent,
  ButtonComponent,
  TextFieldComponent,
  TextareaComponent,
  ChannelComponent,
  CreateTrackInvoiceComponent,
  CreateAdsComponent,
  CreateSiteComponent,
  CreateOrderSiteComponent,
  ConfirmComponent,
  SelectFieldsComponent,
  ModalComponent,
  DialogComponent,
  AdditionalInfoComponent,
  IntegrationTelegramComponent,
  IntegrationNovaposhtaComponent,
  HeaderSidebarComponent,
  TableComponent,
  PaginationComponent,
  PhoneFieldComponent,
  ChannelsComponent,
  RadioComponent,
  SearchComponent,
  FunnelFilterComponent,
  LoaderComponent,
  PropsComponent,
  TariffUpdateComponent,
  ThemesComponent,
  TabsComponent,
  DeliveryChoiceComponent,
  SyncTtnComponent,
  CreateTemplateComponent,
  SyncTtnDetailsComponent,
  VerifyingEmailComponent,
  ResetPasswordComponent,
  AddFieldFilterComponent,
  CheckboxComponent,
  ButtonToggleGroupComponent,
  ToggleComponent,
  ChatSidebarComponent,
  IntegrationCheckboxComponent,
  CreateFunnelComponent,
  CreateColumnComponent,
  BoardColumnEditComponent,
  HiddenInputComponent,
  SnackBarComponent,
  MarketComponent,
  ChartComponent,
  FileViewerComponent,
  MyPacketsComponent,
  IconComponent,
  TagComponent,
  TagsComponent,
  ChatListComponent,
  ChatComponent,
  ChatSettingsComponent,
  ChatAboutComponent,
  ChatListItemComponent,
  ChatMessageComponent,
  ChatTimelineComponent,
  NoResultsComponent,
  IntegrationRiaComponent,
  IntegrationRingostatChannelComponent,
  ReactionsComponent,
  IntegrationInstagramComponent,
  IntegrationFacebookComponent,
  IntegrationTiktokComponent,
  IntegrationActionComponent,
  PriceEditorComponent,
  GroupImagesPickerComponent,
  AdvertCategoryPickerComponent,
  AdvertAttributesEditorComponent,
  StackedSidebarComponent,
  IntegrationViberComponent,
  WriteMessageComponent,
  SelectComponent,
  TabsV2Component,
  TableV2Component,
  TableV2CellDirective,
  TableV2HeaderDirective,
  TableV2RowAfterDirective,
  TableV2EmptyDirective,
  IntegrationWhatsappComponent,
  IntegrationPromComponent,
  AdvertStatisticsChartComponent,
  CompaniesV2Component,
  NeuronAndAnotherCrmComponent,
  IntegrationReviewComponent,
  BoardV3CardDetailComponent,
  BoardV3CardGeneralPanelComponent,
  BoardV3CardCasePanelComponent,
  BoardV3CardCommentsPanelComponent,
  BoardV3CardChatsPanelComponent,
  BoardV3CardTasksPanelComponent,
  BoardV3CardCallsPanelComponent,
  TimelineComponent,
  BoardV3TimelineUpdateComponent,
  BoardV3TimelineReminderComponent,
  BoardV3TimelineCommentComponent,
  BoardV3TimelineCallComponent,
  SectionFieldsDialogComponent,
  CustomFieldControlComponent,
];

const PIPES = [
  DateAgoPipe,
  LinkifyPipe,
  FileSizePipe,
  DaysLeftPipe,
  TruncatePipe,
  FullNamePipe,
  HighlightPipe,
  SafeHtmlPipe,
  MediaSecondsPipe,
  OlxPricePipe,
  EmojiPipe,
];

const MODAL_COMPONENTS = [
  OneFieldComponent,
  ChanelRightBarComponent,
  CreateDealsFields,
  FixTextComponent,
  ChangeOlxPriceComponent,
  SelectCategoryComponent,
  PlannerAutomationComponent,
  NotificationPopupComponent,
  FileUploadNewComponent,
  CsvFieldMappingComponent,
  SuccessLeadComponent,
  ShowAdvertStatisticsComponent,
  BoardSelectFieldsFilterComponent,
];

const DIRECTIVES = [
  InitDirective,
  LoadDirective,
  ResizerDirective,
  DisableAutocompleteDirective,
  ResizeColumnDirective,
  DndDirective,
  VisibilityObserverDirective,
  ScrollDirective,
  LongPressDirective,
  TextareaAutoresizeDirective,
  PhotoGalleryGroupDirective,
  PhotoGalleryDirective,
];

const MENU_COMPONENTS = [NotificationMenuComponent];

const MODULES = [MaterialModule, TranslateModule, EmojiModule, TranslationModuleDirective];

const SIDEBARS = [
  CreateUpdateOlxAdvertComponent,
  BuyOlxPackageComponent,
  AdvertActionComponent,
  BuyOlxAdsBundlesComponent,
  BuyOlxPackagesV2Component,
  PlannerV2Component,
  AutomationLogDetailsComponent,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...TABS,
    ...BOTTOM_SHEETS,
    ...PIPES,
    ...MODAL_COMPONENTS,
    ...DIRECTIVES,
    ...SIDEBARS,
    ...MENU_COMPONENTS,
  ],
  exports: [
    ...COMPONENTS,
    ...TABS,
    ...BOTTOM_SHEETS,
    ...PIPES,
    ...MODAL_COMPONENTS,
    ...DIRECTIVES,
    ...MODULES,
    ...SIDEBARS,
    ...MENU_COMPONENTS,
  ],
  imports: [
    TranslateDirective,
    TranslatePipe,
    TranslationModuleDirective,
    NgxDocViewerModule,
    CommonModule,
    MaterialModule,
    PrimengModule,
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    FormsModule,
    ReactiveFormsModule,
    NgxMaterialIntlTelInputComponent,
    PortalModule,
    NgOptimizedImage,
    CdkContextMenuTrigger,
    CdkMenuItem,
    CdkMenu,
    NgSelectModule,
    A11yModule,
    DragDropModule,
    ScrollingModule,
    CdkExperimentalScrollingModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CdkMenuTrigger,
    CdkConnectedOverlay,
    PickerModule,
    ClipboardModule,
    MarkdownModule.forRoot(),
    LottieComponent,
    NgxSkeletonLoaderModule.forRoot(),
    NgxMatSelectSearchModule,
    Divider,
    ToggleSwitch,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withXhr()),
    provideNgxMask(),
    DatePipe,
    providePrimeNG({
      license: PRIMENG_LICENSE_KEY,
      ripple: true,
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: 'none',
        },
      },
    }),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [DatePipe],
    };
  }
}
